import { messageUserMessageList } from '@/api/message'

const state = {
  message0: [],
  message1: [],
  total0: 0,
  total1: 0
}

const mutations = {
  message0: (state, value) => {
    state.message0 = value
  },
  total0: (state, value) => {
    state.total0 = value
  },
  message1: (state, value) => {
    state.message1 = value
  },
  total1: (state, value) => {
    state.total1 = value
  }
}

const actions = {
  async getMessage({ commit }, { state, ...params }) {
    const resp = await messageUserMessageList({ state, ...params })
    commit(`message${state}`, resp.list || [])
    commit(`total${state}`, resp.total || 0)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

